module.exports = __webpack_public_path__ + "img/PTC.de870935.jpg";